export const genero = [
    {
        value: 1, label: 'Masculino'
    },{
        value: 0, label: 'Femenino'
    },
]